<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  courseListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'
import moment from 'moment'
export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      start: '',
      end: '',
      starttime: '00:00:00',
      endtime: '23:59:00',
      eventError: null,
      isEventError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      eventSuccess: '',
      isSuccess: false,
      timeError: false,
      timeError1: false,
      goneTimeError: false,
      classlist: [],
      collegeId: '',
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
      classEmptyError: false,
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    if (this.role === 'college') {
      this.getDepartments()
    }
    this.collegeId = this.profileData.college_id
    if (this.role === 'hod') {
      // this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...courseListMethod,
    ...userListMethod,
    ...departmentListMethod,

    updateTrainingEventData() {
      if (this.collegeClass.length === 0 || this.departmentId.length === 0) {
        this.classEmptyError = true
        this.isLoading = false
      } else {
        this.classEmptyError = false
      }
      if (!this.classEmptyError) {
        let eventData = {
          id: this.data._id,
          title: this.title,
          department: this.departmentId,
          college_id: this.collegeId,
          collegeClass: this.collegeClass,
        }
        if (
          this.starttime !== '' &&
          this.endtime !== '' &&
          this.starttime > this.endtime &&
          (this.end !== '' && this.start !== '')
        ) {
          this.timeError1 = true
        } else {
          this.timeError1 = false
        }
        if (this.start !== '') {
          let datetime = moment(
            `${this.start} ${this.starttime}`,
            'YYYY-MM-DD HH:mm:ss'
          ).format()
          const now = new Date()
          const today = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            now.getHours(),
            now.getMinutes(),
            now.getSeconds()
          )
          const minDate = new Date(today)
          const d1 = new Date(moment(minDate).format())
          const d2 = new Date(datetime)
          if (d1 > d2) {
            this.goneTimeError = true
          } else {
            this.goneTimeError = false
          }
          eventData.start = datetime
        }
        if (this.end !== '') {
          let datetime = moment(
            `${this.end} ${this.endtime}`,
            'YYYY-MM-DD HH:mm:ss'
          ).format()
          eventData.end = datetime
        }
        if (!this.timeError && !this.timeError1 && !this.goneTimeError) {
          this.updateTrainingEvent({ eventData })
            .then((event) => {
              this.isLoading = false
              this.eventSuccess = 'Training Event Updated Successfully'
              this.isSuccess = true
              window.location.reload()
            })
            .catch((error) => {
              this.isLoading = false
              var getError = new ErrorWrapper(error)
              this.eventError = getError.message
              this.isEventError = true
            })
        }
      }
    },

    getData() {
      this.title = this.data.title
      if (this.data.start.length > 10) {
        this.starttime = this.data.start.slice(11, 19)
      }
      if (this.data.end.length > 10) {
        this.endtime = this.data.end.slice(11, 19)
      }
      this.start = this.data.start.slice(0, 10)
      if (this.data.end !== undefined) {
        this.end = this.data.end.slice(0, 10)
      }
      let i = 0
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
      }
      this.getClasses()
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
      }
    },

    resetModal() {
      this.departmentId = []
      this.title = this.data.title
      this.starttime = ''
      this.endtime = ''
      this.timeError = false
      this.timeError1 = false
      this.start = this.data.start.slice(0, 10)
      if (this.data.end !== undefined) {
        this.end = this.data.end.slice(0, 10)
      } else {
        this.end = ''
      }
      let i = 0
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
      }
      this.classEmptyError = false
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },

    getMinDate1() {
      const now = new Date(this.start)
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    getClasses() {
      this.collegeClass = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="training-event-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isEventError"
          variant="danger"
          v-html="eventError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="eventSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateTrainingEventData">
          <b-form-group label="Event Title" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="title"
              type="text"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Event Start Date" label-for="start">
            <b-form-datepicker
              id="example-datepicker"
              v-model="start"
              :min="getMinDate()"
            ></b-form-datepicker>
          </b-form-group>

          <b-form-group label="Event End Date" label-for="end">
            <b-form-datepicker
              id="example-datepicker1"
              v-model="end"
              :min="getMinDate1()"
            ></b-form-datepicker>
          </b-form-group>
          <label for="example-input">Event Start Time</label>
          <b-form-input
            id="example-time-input"
            v-model="starttime"
            class="form-control"
            type="time"
          >
          </b-form-input>
          <br />

          <label for="example-input1">Event End Time</label>
          <b-form-input
            id="example-time-input1"
            v-model="endtime"
            class="form-control"
            type="time"
          >
          </b-form-input>
          <br />
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <p v-if="classEmptyError" style="color:red;"
            >Please select class/department</p
          >
          <p v-if="timeError1" style="color:red;"
            >Please add end time greater than start time</p
          >
          <p v-if="timeError" style="color:red;"
            >Please add valid start/end time</p
          >
          <p v-if="goneTimeError" style="color:red;">Added past date/time</p>

          <p class="note"
            >Note: If time is not selected then by default event will start at
            12 AM and will end at 11:59 PM.</p
          >
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
